const year = '2025';
const pickUp = 'EUR 47,-';
const adultBreakfast = 'EUR 37,-';
const adult = 'EUR 32,-';
const shortTermStay = 'EUR 3,-';
const children6 = 'EUR 3,- Frühstück';
const children10 = '-40%';
const children15 = '-30%';

export function getPickUp(): string {
    return pickUp;
}

export function getAdult(breakfast: boolean): string {
    return breakfast ? adultBreakfast : adult;
}

export function getChildren(age: number): string {
    if (age <= 6)
        return children6;
    if (age <= 10)
        return children10;
    if (age <= 15)
        return children15;
    return '';
}

export function getShortTermStay(): string {
    return shortTermStay;
}

export function getYear() {
    return year;
}

